import { get } from '@direct-frontend/stdlib';

export const isErrorWithType = <T extends string = string>(error: unknown): error is { responseData: { type: T } } =>
    typeof get(error, ['responseData', 'type']) === 'string';
